import getSessionContext from 'src/utils/context/getSessionContext'
import { make } from 'vuex-pathify'
import makeTableCommonActions from '../../utils/vuexModuleConstructor/vuexTableCommonActionsMaker'
import makeTableCommonGetters from '../../utils/vuexModuleConstructor/vuexTableCommonGettersMaker'
import makeTableCommonState from '../../utils/vuexModuleConstructor/vuexTableCommonStateMaker'

const remoteEntityName = 'ci.availability'

const state = {
  ...makeTableCommonState()
}

const getters = {
  ...makeTableCommonGetters({ remoteEntityName }),

  pageTitle: () => 'Availability',

  controlledActions: () => {
    return { // 0 if anyone can. -1 if disabled (i.e., no one can); 'creator' -- if only user with id same as created_by_user_id
      create: 0,
      fetch: 0,
      update: 0,
      delete: 0,
      downloadList: 0,
      uploadList: -1
    }
  },

  controllerDefaultParams: (state, getters, rootState) => {
    return {
      fetch: { org_id: getSessionContext().org_id }
    }
  },

  columns: (state, getters, rootState, rootGetters) => {
    const isDirectOverrideAlertTooltipContentt = props => {
      const currentSystemRecommendation = state.list.find(r => r.class_id === props.row.class_id && r.tier_id === props.row.tier_id && !r.is_direct_override && !r.is_override_through_rules && r.is_active) || {}
      const text = `
        <span style="font-weight:500">This is a direct override:</span>
        <br>By ${props.row.created_by_user_name}
        <br>At ${Intl.DateTimeFormat([], { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }).format(new Date(props.row.created_at))}
        ${props.row.notes ? '<br>Notes: ' + props.row.notes : ''}
        <hr>
        <span style="font-weight:500">Current system recommendation:</span>
        <br>Availabile spots: ${(currentSystemRecommendation || {}).available_spots || 'unknown'}
        <br>Price: ${(currentSystemRecommendation || {}).price || 'unknown'}
        <hr>
        <span style="font-weight:500">System recommendation at time of override:</span>
        <br>Availabile spots: ${(props.row.system_recommendation_at_time_of_override || {}).available_spots || 'unknown'}
        <br>Price: ${(props.row.system_recommendation_at_time_of_override || {}).price || 'unknown'}
        `
      return text
    }

    return [
      { name: 'id', label: 'ID', style: 'width:50px', field: 'id', align: 'left', hideWhenCreating: true, isNumeric: true },
      { name: 'is_direct_override_alert', isIcon: true, icon: 'mdi-alert', tooltipContentIsHTML: true, tooltipContent: props => isDirectOverrideAlertTooltipContentt(props), cellContentIsShown: props => props.row.is_direct_override, tdStyles: { padding: '4px 0 4px 4px', color: 'var(--q-color-negative)' } },
      { name: 'is_direct_override_info', isIcon: true, icon: 'mdi-information-variant', tooltipContentIsHTML: true, tooltipContent: props => isDirectOverrideAlertTooltipContentt(props), isHidden: data => !data.some(r => r.is_direct_override), cellContentIsShown: props => props.row.is_direct_override, tdStyles: { padding: '4px 0 4px 4px', color: 'var(--q-color-dark)' } },
      { name: 'notes', style: 'min-width: 150px', label: 'Notes', field: 'notes' },
      { name: 'notes_icon', isIcon: true, icon: 'mdi-text', tooltipContent: props => props.row.notes, cellContentIsShown: props => props.row.notes && props.row.notes.length > 0 },

      { name: 'class_id', align: 'left', thStyles: 'white-space:nowrap', label: 'Class ID', field: 'class_id', uiFilterTypes: ['selectedValuesFilter'] },
      { name: 'class_location', label: 'Location', style: 'white-space:nowrap', valueGetter: props => rootGetters['ci.classes/getReferencedObjectByReferencingObjectIdAndColumnName'](props.row.class_id, 'location_id').name, align: 'left', uiFilterTypes: ['selectedValuesFilter'] },
      { name: 'class_type', label: 'Class type', style: 'white-space:nowrap', valueGetter: props => rootGetters['ci.classes/getReferencedObjectByReferencingObjectIdAndColumnName'](props.row.class_id, 'class_type_id').name, align: 'left', uiFilterTypes: ['selectedValuesFilter'] },
      { name: 'class_date', label: 'Class date', valueGetter: props => rootGetters['ci.classes/getObjectById'](props.row.class_id).start_date, isDate: true, uiFilterTypes: ['dateFilters'] },
      { name: 'class_time', label: 'Class time', valueGetter: props => rootGetters['ci.classes/getObjectById'](props.row.class_id).start_time, isTime: true, uiFilterTypes: ['selectedValuesFilter'] },

      { name: 'broker_id', label: 'Broker', field: 'broker_id', references: 'ci.brokers' },
      { name: 'is_active', align: 'center', label: 'Active', field: 'is_active', isCheckbox: true, tooltipContent: 'Is active?' },
      { name: 'is_currently_in_effect', label: 'Currently in effect', align: 'center', field: 'is_currently_in_effect', tooltipContent: 'Is currently in effect?', isCheckbox: true },
      { name: 'available_spots', label: 'Available spots', tooltipContent: 'Available spots', field: 'available_spots', defaultValueWhenCreating: 0 },
      { name: 'already_booked_spots', label: 'Already booked spots', tooltipContent: 'Already booked spots', field: 'already_booked_spots', isNumeric: true, isInteger: true, hideWhenCreating: true, showZeroInPlaceOfNull: true },
      { name: 'price', label: 'Price', tooltipContent: 'Price', field: 'price', isCurrency: true, defaultValueWhenCreating: 0 },
      { name: 'is_direct_override', label: 'Direct override', field: 'is_direct_override', isCheckbox: true, align: 'center' },
      { name: 'is_override_through_rules', label: 'Override through rules', field: 'is_override_through_rules', isCheckbox: true, align: 'center' },
      { name: 'created_at', style: 'white-space:nowrap', label: 'Created at', field: 'created_at', isDateTime: true },
      { name: 'created_by_user_id', label: 'Created by', field: 'created_by_user_id', hideWhenDisplaying: true, hideWhenCreating: true },
      { name: 'created_by_user_name', style: 'white-space:nowrap', label: 'Created by', field: 'created_by_user_name', hideWhenCreating: true },
      { name: 'inactivated_at', style: 'white-space:nowrap', label: 'Inactivated at', field: 'inactivated_at', isDateTime: true },
      // { name: 'inactivated_by_user_id', label: 'Inactivated by', field: 'inactivated_by_user_id' },
      { name: 'inactivated_by_user_name', style: 'white-space:nowrap', label: 'Inactivated by', field: 'inactivated_by_user_name' },
      { name: 'became_effective_at', style: 'white-space:nowrap', label: 'Became effective at', field: 'became_effective_at', isDateTime: true },
      { name: 'stopped_being_effective_at', style: 'white-space:nowrap', label: 'Stopped being effective at', field: 'stopped_being_effective_at', isDateTime: true }
    ]
  }
}

const mutations = make.mutations(state)
const namespaced = true

const actions = {
  ...makeTableCommonActions()
}

export default { state, actions, mutations, getters, namespaced }
